import {
  info,
  option,
  options,
  price,
  selected,
  title,
  unavailable,
  wrapper
} from './variation.module.scss';
import { useEffect, useState } from 'react';

import Image from 'next/image';
import { OUT_OF_STOCK } from 'Lib/constants/product';
import SiteImage from 'Components/Common/SiteImage';
import classNames from 'classnames';
import { cloudinaryLoader } from 'functions';
import { getDefaultSelection } from 'utils/productCollectionUtils';

export default function Variation({ variations, onSelect, className }) {
  const [selectedVariation, setSelectedVariation] = useState(null);

  const handleSelection = (elem) => {
    if (elem.stockStatus !== OUT_OF_STOCK) {
      setSelectedVariation(elem);
      onSelect(elem);
    }
  };

  useEffect(() => {
    if(variations.length) {
      setSelectedVariation(getDefaultSelection(variations))
    }
  }, [variations])

  return (
    <div className={classNames(wrapper, className)}>
      {variations.map((elem) => {
        const variationName = elem.attributes.nodes[0].value;
        return (
          <div
            key={elem.id}
            className={classNames(
              `${selectedVariation?.databaseId == elem.databaseId ? selected : ''
              }`,
              options,
              elem.stockStatus === OUT_OF_STOCK ? unavailable : null
            )}
          >
            <div className={option} onClick={() => handleSelection(elem)}>
              {elem.image && (
                <SiteImage
                  alt={variationName}
                  height={40}
                  width={40}
                  src={
                    elem?.image?.cloudinaryResource?.url_suffix ||
                    elem?.image?.sourceUrl
                  }
                  loader={
                    elem?.image?.cloudinaryResource ? cloudinaryLoader : ''
                  }
                />
              )}
              <div className={info}>
                <p className={title}>{variationName}</p>
                {/* <p
                  className={price}
                  dangerouslySetInnerHTML={{ __html: elem.price }}
                /> */}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
